import { PushNotifications } from "@capacitor/push-notifications";
import { ExceptionCode } from "@capacitor/core";
import appConfig from "../appconfig";

export const checkCapacitorPushPermissions = async () => {
	if (!appConfig.mobile.isMobileApp()) return;
	try {
		const { receive } = await PushNotifications.checkPermissions();
		return receive;
	} catch (error) {
		if (error.code === ExceptionCode.Unimplemented) {
			return "denied";
		}
		throw new Error("Error checking push permissions");
	}
};

export const requestCapacitorPushPermissions = async () => {
	if (!appConfig.mobile.isMobileApp()) return;
	try {
		const { receive } = await PushNotifications.requestPermissions();
		return receive;
	} catch (error) {
		if (error.code === ExceptionCode.Unimplemented) {
			return "denied";
		}
		throw new Error("Error requesting push permissions");
	}
};

export const registerCapacitorPushNotifications = async () => {
	if (!appConfig.mobile.isMobileApp()) return;
	try {
		await PushNotifications.register();
	} catch (error) {
		if (error.code === ExceptionCode.Unimplemented) {
			return;
		}
		throw new Error("Error registering push notifications");
	}
};

export const addCapacitorPushListener = async (eventName, callback) => {
	if (!appConfig.mobile.isMobileApp()) return;
	try {
		await PushNotifications.addListener(eventName, callback);
	} catch (error) {
		if (error.code === ExceptionCode.Unimplemented) {
			return;
		}
		throw new Error(`Error adding listener for ${eventName}`);
	}
};
